<app-loader [Parent]="this"></app-loader>

@if (!HideSearch) {
  <form>
    <div class="dlv-bar mr-3 mb-5 p3">
      <ng-content></ng-content>
    </div>
  </form>
}
<div class="columns loading-container">
  <div class="column" [ngClass]="ShowMap ? 'is-6' : 'is-12'">
    <div class="level mb-0 pb-0">
      <div class="level-left pl-2">
        <!-- <div *ngIf="AllowAdd == true && AddHasOptions == true" class="level-item">
        <div class="dropdown" (click)="showAddDropdown=!showAddDropdown"
          [ngClass]="showAddDropdown ? 'is-active' : ''">
          <div class="dropdown-trigger">
            <button class="button is-primary is-small" aria-haspopup="true"
              aria-controls="dropdown-menu">
              <span class="fa fa-plus"></span>
              <span>Add</span>
              <span class="icon is-small">
                <i class="fa fa-angle-down" aria-hidden="true"></i>
              </span>
            </button>
          </div>
          <div class="dropdown-menu" id="dropdown-menu" role="menu">
            <div class="dropdown-content">
              <a class="dropdown-item" *ngFor="let a of AddUrl" (click)="AddNewByRoute(a[1])">
                {{a[0]}}
              </a>
            </div>
          </div>
        </div>
      </div> -->
      @if (Data.Results != null && ShowPaging == true && !AllowAllResults) {
        <div class="level-item">
          <button class="button pagination-button is-small mr-3" (click)="PrevPage()"><i class="fa fa-chevron-left"></i></button>
          Showing &nbsp;@if (Data.Results.length != 0) {
          <span class="has-text-weight-bold">{{(Data.PageSize * (Data.PageNumber-1))+1}}</span>
        }
        @if (Data.Results.length != 0) {
          <span>&nbsp; to &nbsp;</span>
        }
        <span class="has-text-weight-bold">{{(Data.TotalRecords <= ((Data.PageSize * (Data.PageNumber-1))+Data.PageSize)) ? Data.TotalRecords :
        ((Data.PageSize * (Data.PageNumber-1))+Data.PageSize)}}</span>
        &nbsp; of &nbsp;
        <span class="has-text-weight-bold">{{Data.TotalRecords}}</span>
        <button class="button pagination-button is-small ml-3" (click)="NextPage()"><i class="fa fa-chevron-right"></i></button>
      </div>
    }
  </div>

  <div class="level-right">
    <div class="level-item">
      @if (ShowPaging == true && !AllowAllResults) {
        <div class="select">
          <select [(ngModel)]="Filter.PageSize" (change)="PageSizeChanged()">
            <option [value]="10">10</option>
            <option [value]="15">15</option>
            <option [value]="25">25</option>
            <option [value]="50">50</option>
            <option [value]="100">100</option>
            <option [value]="250">250</option>
            <option [value]="500">500</option>
          </select>
        </div>
      }
    </div>
  </div>

</div>

<table class="table is-striped">
  @if (ShowColumnHeaders) {
    <thead>
      <tr>
        @if (AllowSelectBoxes) {
          <th style="width:4em">
          </th>
        }
        @for (h of Columns; track h) {
          <th (click)="ApplySort(h)" [ngStyle]='{width: h.Width}'>{{h.Header}}
            @if (h.EnableFilter) {
              <div style="display:inline; position:relative; margin-left:2em;">
                <i style="position:absolute; top:-4px;" [ngStyle]="{'color': IsFilterOn(h, true) ? 'black' : 'lightgrey'}" class="fa fa-chevron-up"></i>
                <i style="position:absolute; top:7px;" [ngStyle]="{'color': IsFilterOn(h, false) ? 'black' : 'lightgrey'}" class="fa fa-chevron-down"></i>
              </div>
            }
          </th>
        }
        @if (ShowIssues) {
          <th style="width:4em">
            <!-- to mark items as issue -->
          </th>
        }
        <th class="buttoncolumn">
        </th>
      </tr>
    </thead>
  }
  <tbody>
    @for (row of Data.Results; track row) {
      <tr [ngClass]="{'is-selected': (row.Id === SelectedRow && HighlightOnSelect),'issue': (row.Issues != null && row.Issues.length > 0)}"
        (click)="RowClicked(row, $event)" (dblclick)="EditItem(row)" (mousedown)="RowNonPrimaryClicked(row,$event)">
        @if (AllowSelectBoxes) {
          <td style="width:4em" [ngClass]="getClass(row)">
            @if (CanShowSelectBox(row)) {
              <app-toggleswitch [value]="IsInSelectedItems(row)" (change)="RowSelectChanged($event, row)"></app-toggleswitch>
            }
          </td>
        }
        @for (col of Columns; track col) {
          @if (col.RendersHtml) {
            <td [ngStyle]="col.IsIcon ? { 'width': '1em' } : null" [innerHTML]="sanitizer.bypassSecurityTrustHtml(col.Render(row))"
              [ngClass]="getClass(row)">
            </td>
          } @else {
            <td [ngStyle]="col.IsIcon ? { 'width': '1em' } : null" [ngClass]="getClass(row)">{{ col.Render(row) }}</td>
          }
        }
        @if (ShowIssues) {
          <td>
            @if (row.Issues.length > 0) {
              <div class="icon-container">
                @for (issue of row.Issues; track issue) {
                  <i  [tippy]="issue.IssueDescription" [ngClass]="'Icon fa fa-' + issue.IssueIcon + ' Flash ' + issue.Severity" [ngStyle]="{'color': '#' + issue.IssueIconColor}" style="font-size: 1.5em; margin-top:5px; text-align:center;"></i>
                }
              </div>
            }
          </td>
        }
        <td class="buttoncolumn" [ngClass]="getClass(row)">
          @if (AllowEdit) {
            <button type="button" class="button is-link is-small"
              (click)="EditItem(row)"><i class="fa fa-chevron-right"></i></button>
            }
            @if (AllowDuplicate) {
              <button type="button" class="button is-info is-small ml-1"
                (click)="DuplicateItem(row)"
                title="Duplicate">
                <i class="fa fa-copy"></i>
              </button>
            }
            @if (AllowSelect) {
              <button type="button" class="button is-primary" (click)="SelectItem(row)">
                <span class="icon-text">
                  <span class="icon">
                    <i class="fa fa-chevron-right"></i>
                    </span><span>Select</span>
                  </span>
                </button>
              }
              @if (ShowCustomAction(row)) {
                <button type="button" class="button is-primary is-small"
                  (click)="CustomActionOnAction(row)">
                  <span class="icon-text">
                    <span>{{CustomActionText}}</span>
                    <span class="icon pt-2">
                      <i class="fa fa-{{CustomActionIcon}}"></i>
                    </span>
                  </span>
                </button>
              }
              @if (AllowDropdownActions && ActionsOnRow(row)) {
                <div class="is-right" style="display: inline-flex;width: 2em;margin-left: 3em;">
                  <div class="dropdown is-hoverable is-right" style="color:black">
                    <div class="dropdown-trigger">
                      <span class="icon">
                        <i class="fa-solid fa-ellipsis fa-lg" aria-hidden="true"></i>
                      </span>
                    </div>
                    <div class="dropdown-menu" id="dropdown-menu2" role="menu">
                      @if (!UseActionsOnEachItem) {
                        <div class="dropdown-content">
                          @for (action of this.DropdownActions; track action; let i = $index) {
                            @if (ShowAction(row, i)) {
                              <a class="dropdown-item" (click)="DropdownActionCalled(row, i)">
                                <p>{{ action.text }}</p>
                              </a>
                            }
                          }
                        </div>
                      }
                      @if (UseActionsOnEachItem) {
                        <div class="dropdown-content">
                          @for (action of GetActionsForItem(row); track action; let i = $index) {
                            <a class="dropdown-item" (click)="DropdownActionOnItemCalled(row, action)">
                              <p>{{ action.text }}</p>
                            </a>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
              @if (AllowDelete) {
                <button type="button" class="button is-danger is-small"
                  (click)="DeleteOnAction(row)">
                  <span class="icon-text">
                    <span class="icon">
                      <i class="fa fa-trash"></i>
                    </span>
                  </span>
                </button>
              }
            </td>
          </tr>
        }
      </tbody>
      @if (Data.Results != null && Data.Results.length == 0) {
        <tfoot>
          <td colspan="999" class="has-text-centered">No Results!</td>
        </tfoot>
      }
    </table>
    @if (ShowPaging == true && !AllowAllResults) {
      <div class="pr-3 mt-3">
        <nav class="pagination  is-right" role="navigation" aria-label="pagination">
          <ul class="pagination-list">
            <li>
              <a class="pagination-previous" (click)="PrevPage()"><i class="fa fa-chevron-left"></i></a>
            </li>
            @for (p of Pages; track p) {
              <li>
                @for (i of p; track i) {
                  <a class="pagination-link"
                  [ngClass]="{ 'is-current' : i == Filter.PageNumber}" (click)="GotoPage(i)">{{i}}</a>
                }
                @if (p != Pages[Pages.length-1]) {
                  <a class="pagination-ellipsis">&hellip;</a>
                }
              </li>
            }
            <li>
              <a class="pagination-next" (click)="NextPage()"><i class="fa fa-chevron-right"></i></a>
            </li>
          </ul>
        </nav>
      </div>
    }
  </div>
  @if (ShowMap) {
    <div class="column is-6" style="min-height: 80vh">
      <app-structureviewermaps #StructureViewer [Layers]="StructureViewerLayers" [ShowLotSelect]="true" [ShowLevelSelect]="true" [StructureViewerForType]="StructureViewerForType"></app-structureviewermaps>
    </div>
  }

</div>